import {gql} from '@apollo/client';
import {getMetaTagsRequestPath, isPropertyDeepLink, setMetaTags} from '../../helpers/common';
import apolloClient from '../../store/apolloClient';
import {notifyPanelReady} from '../../utilities/pageViewTracker';

/**
 * Refresh document metatags from GraphQL.
 *
 * @param {string} [currentPath] - Pathname or full path; defaults to meta-tags request path.
 * @param {{ forceMarket?: boolean }} [options] - forceMarket: apply market tags even on ?folio= URLs.
 */
function refreshMetatags(currentPath, options = {}) {
  const {forceMarket = false} = options;
  if (!forceMarket && isPropertyDeepLink()) {
    return Promise.resolve(null);
  }

  const requestPath = currentPath || getMetaTagsRequestPath();

  const pageDataGql = path => gql`
    {
      metaTags(path: "${path}")
    }
  `;
  return apolloClient
    .query({
      query: pageDataGql(requestPath),
    })
    .then((res) => {
      setMetaTags(res?.data?.metaTags?.metatags);
      notifyPanelReady();
      return res;
    });
}

export default refreshMetatags;
